'use client';

import { H2Large } from './styleConstants';
import { Container } from '..';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import { useAutoPlayVideoOnIntersection } from '..';
import { useEffect, useState } from 'react';
import { ReplayIcon } from 'assets/icons';
import { useTranslations } from 'next-intl';
import styles from './TitleVideoAutoplaySection.module.css';

export const TitleVideoAutoplaySection = ({
  className,
  title,
  src,
  srcResponsive,
  videoBorderRadius = '0px',
}: {
  className?: string;
  title?: string | React.ReactNode;
  src: string;
  srcResponsive: string;
  videoBorderRadius?: string;
}) => {
    const t = useTranslations('powerplugs');
    const [replayVisible, setReplayVisible] = useState(false);
    const videoRef = useAutoPlayVideoOnIntersection();
    const { width } = useWindowSize();

    useEffect(() => {
      if (!videoRef.current) {
        return;
      }
      videoRef.current.onended = () => {
        setReplayVisible(true);
      };

      videoRef.current.onplay = () => {
        setReplayVisible(false);
      };
    }, []);

    return (
      <section
        className={[styles.root, className].filter(Boolean).join(' ')}
        data-has-title={title ? 'true' : 'false'}
        style={{
          borderRadius: videoBorderRadius,
          overflow: title ? 'unset' : 'hidden',
        }}
      >
        {title ? (
          <Container>
            <H2Large>{title}</H2Large>
            <p>{t('powerplugsPage.titleVideoAutoplay.subtitle')}</p>
          </Container>
        ) : null}
        <div className={styles.videoContainer}>
          {/* {width < 678 ? srcResponsive : src} */}
          {width < 678 ? (
            <video
              preload="none"
              autoPlay
              muted
              playsInline
              ref={videoRef}
              key="mobile"
            >
              <source src={srcResponsive} type="video/mp4" />
            </video>
          ) : (
            <video
              preload="none"
              autoPlay
              muted
              playsInline
              ref={videoRef}
              key="desktop"
            >
              <source src={src} type="video/mp4" />
            </video>
          )}
          {replayVisible ? (
            <button
              data-buttontype="animation replay"
              className={styles.replayBtn}
              onClick={() => {
                videoRef.current?.play();
                setReplayVisible(false);
              }}
            >
              <ReplayIcon
                fill="black"
                style={{
                  height: '16px',
                  width: 'auto',
                  opacity: '0.7',
                }}
              />{' '}
              {t('powerplugsPage.titleVideoAutoplay.replay')}
            </button>
          ) : null}
        </div>
      </section>
    );
};
